import React from 'react';
import AppListComponents from '../components/AppListComponents';

const AppList = () => {
  return (
    <div className="p-6" style={{ backgroundColor: '#C6D2ED', minHeight: '100vh' }}>
      <AppListComponents />
    </div>
  );
};

export default AppList;